import { Translation } from '@ps/web-shared-components';
import React from 'react';

import UnderMaintenance from '../../assets/under_maintenance.svg';

import { TXTCLI_The_Spin_X_Go_tournaments_are__ELL } from './Maintenance.messages.json';
import styles from './Maintenance.scss';

const Maintenance: React.FC = () => (
  <div className={styles.container}>
    <UnderMaintenance />
    <Translation tagName="div" {...TXTCLI_The_Spin_X_Go_tournaments_are__ELL} />
  </div>
);

export default Maintenance;
